import { motion } from "framer-motion";
import { ArrowUpRight, Code2, Layers, Figma, Bug, Rocket, Globe2 } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const ICONS = [Code2, Layers, Figma, Bug, Rocket, Globe2];
const ACCENTS = ["#ccff00", "#ff4500", "#ff00cc", "#ccff00", "#ff4500", "#ff00cc"];

const Services = () => {
  const { t } = useLang();

  return (
    <section
      id="services"
      className="relative px-6 md:px-10 py-24 md:py-32 border-t border-white/10"
      data-testid="services-section"
    >
      <div className="max-w-[1500px] mx-auto">
        <div className="text-xs uppercase tracking-[0.3em] text-[#ccff00] mb-6">
          {t.sectionLabels.services}
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-display text-[10vw] md:text-6xl lg:text-7xl whitespace-pre-line max-w-4xl"
          data-testid="services-title"
        >
          {t.services.title}
        </motion.h2>
        <p className="mt-6 text-white/60 max-w-2xl text-base md:text-lg leading-relaxed">
          {t.services.sub}
        </p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {t.services.items.map((item, i) => {
            const Icon = ICONS[i] || Code2;
            const accent = ACCENTS[i];
            return (
              <motion.article
                key={item.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
                className="invert-card group relative border border-white/10 rounded-3xl p-7 md:p-8 bg-[#131313] min-h-[260px] flex flex-col justify-between cursor-default"
                data-testid={`service-card-${i + 1}`}
                style={{ "--accent": accent }}
              >
                <div className="flex items-start justify-between">
                  <span className="font-display text-3xl text-white/30 group-hover:text-black/40 transition">
                    {item.n}
                  </span>
                  <span
                    className="inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-white/10 group-hover:border-black/30 group-hover:bg-black/10 transition"
                    style={{ color: accent }}
                  >
                    <Icon size={22} className="group-hover:!text-black transition" />
                  </span>
                </div>
                <div>
                  <h3 className="font-display text-2xl md:text-3xl mb-3">{item.title}</h3>
                  <p className="invert-muted text-sm text-white/60 leading-relaxed">
                    {item.short}
                  </p>
                </div>
                <ArrowUpRight
                  size={20}
                  className="invert-arrow absolute top-7 right-7 opacity-0 group-hover:opacity-100 transition"
                />
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
